import {
  cn
} from "./O62HZC57.jsx";

// src/Inputs/LabeledGroup.tsx
import { createMemo, Show } from "solid-js";
import { FormField } from "@magicdoor/form";
var LabeledGroup = (props) => {
  const id = createMemo(() => props.id || (typeof props.label === "string" ? props.label.replace(/[^a-zA-Z0-9]/g, "") : ""));
  const isInvalid = createMemo(() => !!props.error);
  const renderLabelContent = createMemo(() => {
    if (props.labelJSX) {
      return props.labelJSX;
    }
    if (props.label) {
      return <>
          <>{props.label}</>
          <Show when={props.required}>
            <span class="text-error"> *</span>
          </Show>
        </>;
    }
    return null;
  });
  return <FormField as="div" class={cn("relative", props.class || props.groupClass)}>
      <div class={cn("flex flex-col", props.labelContainerClass)}>
        <Show when={props.label || props.labelJSX}>
          <label class={cn("text-label mb-0 flex text-sm uppercase md:mb-2", props.labelClass)} for={id()}>
            {renderLabelContent()}
          </label>
        </Show>
        {props.children}
      </div>
      <Show when={isInvalid()}>
        <span class="mt-2 text-left text-xs normal-case text-red-500">{props.error}</span>
      </Show>
    </FormField>;
};

export {
  LabeledGroup
};
